import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiUrl } from "../config/api";
// no routing hook needed; open detail in new tab via window.open

function pad4(n) { return String(n).padStart(4, '0'); }

export default function GroupsPage() {
  useEffect(() => { document.title = 'Группы карточек расчётов'; }, []);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [createOpen, setCreateOpen] = useState(false);
  const [description, setDescription] = useState("");
  const [objects, setObjects] = useState([]);
  const [objQuery, setObjQuery] = useState("");
  const [selectedObject, setSelectedObject] = useState(null);
  const now = new Date();
  const [fromMonth, setFromMonth] = useState(now.getMonth() + 1);
  const [fromYear, setFromYear] = useState(now.getFullYear());
  const [toMonth, setToMonth] = useState(now.getMonth() + 1);
  const [toYear, setToYear] = useState(now.getFullYear());
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({ id: "", name: "", period: "", status: "", description: "", createdAt: "" });
  const [onlyActual, setOnlyActual] = useState(false);
  // no navigate: open in new tab

  const API = apiUrl('/api/card-groups');

  const load = useCallback(() => {
    setLoading(true);
    setError("");
    fetch(API)
      .then((r) => r.json())
      .then((data) => {
        const arr = Array.isArray(data) ? data : [];
        setGroups(arr);
        setLoading(false);
      })
      .catch(() => { setError("Ошибка загрузки групп"); setLoading(false); });
  }, [API]);

  useEffect(() => { load(); }, [load]);
  const onFilterChange = (k, v) => setFilters((s) => ({ ...s, [k]: v }));
  const fillFilterByCell = (k, val, e) => { if (e && e.ctrlKey) { e.stopPropagation(); setFilters(s=>({ ...s, [k]: String(val??'').trim() })); return true; } return false; };

  const filtered = groups.filter((g) => {
    const total = Number(g.totalCount || 0);
    const signed = Number(g.signedCount || 0);
    const actual = Number(g.actualCount || 0);
    const status = total > 0 ? (actual === total ? 'актуален' : (signed === total ? 'согласован' : 'черновик')) : 'черновик';
    const period = (g.fromMonth && g.fromYear && g.toMonth && g.toYear)
      ? `${String(g.fromMonth).padStart(2,'0')}.${g.fromYear} — ${String(g.toMonth).padStart(2,'0')}.${g.toYear}`
      : '';
    const f = {
      id: (filters.id||'').toLowerCase(),
      name: (filters.name||'').toLowerCase(),
      period: (filters.period||'').toLowerCase(),
      status: (filters.status||'').toLowerCase(),
      description: (filters.description||'').toLowerCase(),
      createdAt: (filters.createdAt||'').toLowerCase(),
    };
    const createdAt = g.createdAt ? new Date(g.createdAt).toLocaleString().toLowerCase() : '';
    return (
      (f.id==='' || String(g.id).toLowerCase().includes(f.id)) &&
      (f.name==='' || String(g.name||'').toLowerCase().includes(f.name)) &&
      (f.period==='' || period.toLowerCase().includes(f.period)) &&
      (f.status==='' || status.includes(f.status)) &&
      (f.description==='' || String(g.description||'').toLowerCase().includes(f.description)) &&
      (f.createdAt==='' || createdAt.includes(f.createdAt)) &&
      (!onlyActual || (total>0 && actual===total))
    );
  });
  useEffect(() => {
    // подгрузим объекты для поиска
    fetch(apiUrl('/api/objects'))
      .then(r => r.json())
      .then(data => setObjects(Array.isArray(data) ? data : []))
      .catch(()=>{});
  }, []);

  const handleCreate = () => {
    if (!selectedObject) return alert('Выберите объект');
    const safeFrom = new Date(Number(fromYear), Number(fromMonth)-1, 1);
    const safeTo = new Date(Number(toYear), Number(toMonth)-1, 1);
    if (safeTo < safeFrom) return alert('Период некорректен: "по" раньше, чем "с"');
    fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description: description || "",
        // отправляем name на случай старой версии бэкенда, которая его требует
        name: selectedObject?.name || "",
        objectId: selectedObject.id,
        fromMonth, fromYear, toMonth, toYear,
      }),
    })
      .then(async (r) => {
        const ct = r.headers.get('content-type') || '';
        let data = null;
        try { data = ct.includes('application/json') ? await r.json() : JSON.parse(await r.text()); } catch { data = null; }
        if (!r.ok || !data || !data.id) {
          const msg = (data && data.error) ? data.error : `HTTP ${r.status}`;
          throw new Error(`Не удалось создать группу: ${msg}`);
        }
        return data;
      })
      .then(async (g) => {
        // Если бекенд вернул запись без objectId/периода/кода, добьём PATCH-ом
        if (!g.objectId || !g.fromMonth || !g.fromYear || !g.toMonth || !g.toYear || !g.groupCode) {
          try {
            await fetch(`${API}/${g.id}`, {
              method: 'PATCH', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                objectId: selectedObject?.id, // разрешено сервером, если в БД было NULL
                fromMonth, fromYear, toMonth, toYear,
              })
            }).then(r=>r.json());
          } catch {}
        }
        setDescription("");
        setSelectedObject(null);
        setCreateOpen(false);
        const url = `${window.location.origin}/groups/${g.id}`;
        window.open(url, '_blank');
        load();
      })
      .catch((e) => alert("Ошибка создания: " + (e?.message || e)));
  };

  const journalWrapperStyle = {
    background: "var(--bg-card, #fff)",
    borderRadius: 20,
    border: "1px solid var(--border-200, #e6e8ef)",
    boxShadow: "var(--shadow-1, 0 22px 44px rgba(15,23,42,0.08))",
    overflowX: "auto",
  };
  const journalTableStyle = {
    borderCollapse: "separate",
    borderSpacing: 0,
    width: "100%",
    tableLayout: "fixed",
    borderRadius: 18,
    overflow: "hidden",
    fontSize: 15,
  };
  const thBase = {
    border: "1px solid var(--border-200, #e6e8ef)",
    padding: "10px 12px",
    background: "linear-gradient(135deg, var(--brand-50, #f5efff), #f3f4f8)",
    fontWeight: 700,
    textAlign: "left",
    color: "var(--text-700, #2b2f36)",
    whiteSpace: "normal",
  };
  const filterTh = {
    ...thBase,
    fontWeight: 500,
    background: "#fdfdff",
  };
  const tdBase = {
    border: "1px solid var(--border-200, #e6e8ef)",
    padding: "10px 12px",
    background: "#fff",
    textAlign: "left",
    whiteSpace: "normal",
    wordBreak: "break-word",
  };
  const filterInputStyle = { width: "100%", padding: "6px 8px", fontSize: 13, borderRadius: 8, border: "1px solid #cfd4e1", boxSizing: "border-box", minWidth: 0 };
  const rowBaseStyle = {
    transition: "background 0.18s ease, box-shadow 0.18s ease",
    cursor: "pointer",
  };
  const selectedRowExtras = {
    background: "rgba(86,61,255,0.12)",
    boxShadow: "inset 0 0 0 2px rgba(86,61,255,0.35)",
    outline: "2px solid rgba(86,61,255,0.35)",
    outlineOffset: -2,
  };

  const statusBadgeStyle = (status) => {
    const base = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "4px 10px",
      borderRadius: 999,
      fontWeight: 700,
      fontSize: 13,
      width: "100%",
      boxSizing: "border-box",
    };
    if (status === 'Актуален') return { ...base, background: "#e0edff", color: "#1d4ed8" };
    if (status === 'Согласован') return { ...base, background: "#dcfce7", color: "#15803d" };
    return { ...base, background: "#fef3c7", color: "#92400e" };
  };
  const journalLinkStyle = {
    color: '#1d4ed8',
    textDecoration: 'underline',
    fontWeight: 600,
  };

  return (
    <>
      <div style={{ padding: "32px 0 0 0" }}>
        <h2 style={{ textAlign: "center", margin: "0 0 14px 0" }}>Журнал групп</h2>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <button
            onClick={() => setOnlyActual(v=>!v)}
            style={{ padding: '6px 10px', borderRadius: 6, background: onlyActual? '#e7f0ff':'#f6f7fb', border: onlyActual? '1px solid #2b6cb0':'1px solid #bbb' }}
            title="Показывать только актуальные группы"
          >{onlyActual? 'Только актуальные: ВКЛ':'Только актуальные'}</button>
          <button
            onClick={() => setCreateOpen(true)}
            style={{ padding: "8px 12px", background: "#e7f6d4", border: "1px solid #8bc34a", borderRadius: 6 }}
          >Создать группу</button>
        </div>

        {loading ? (
          <div style={{ textAlign: "center" }}>Загрузка…</div>
        ) : error ? (
          <div style={{ textAlign: "center", color: "#c00" }}>{error}</div>
        ) : (
          <>
            <div style={journalWrapperStyle} className="journal-card">
              <table style={journalTableStyle} className="journal-table">
                <thead>
                <tr>
                  <th style={thBase}>ID</th>
                  <th style={thBase}>Название</th>
                  <th style={thBase}>Период</th>
                  <th style={thBase}>Статус</th>
                  <th style={thBase}>Описание</th>
                  <th style={thBase}>Создана</th>
                  <th style={thBase}></th>
                </tr>
                <tr>
                  <th style={filterTh}>
                    <input value={filters.id} onChange={e=>onFilterChange('id', e.target.value)} placeholder="Поиск..." style={filterInputStyle} />
                  </th>
                  <th style={filterTh}>
                    <input value={filters.name} onChange={e=>onFilterChange('name', e.target.value)} placeholder="Поиск..." style={filterInputStyle} />
                  </th>
                  <th style={filterTh}>
                    <input value={filters.period} onChange={e=>onFilterChange('period', e.target.value)} placeholder="мм.гггг — мм.гггг" style={filterInputStyle} />
                  </th>
                  <th style={filterTh}>
                    <input value={filters.status} onChange={e=>onFilterChange('status', e.target.value)} placeholder="Черновик/Согласован/Актуален" style={filterInputStyle} />
                  </th>
                  <th style={filterTh}>
                    <input value={filters.description} onChange={e=>onFilterChange('description', e.target.value)} placeholder="Поиск..." style={filterInputStyle} />
                  </th>
                  <th style={filterTh}>
                    <input value={filters.createdAt} onChange={e=>onFilterChange('createdAt', e.target.value)} placeholder="Дата/время" style={filterInputStyle} />
                  </th>
                  <th style={filterTh}></th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan={7} style={{ ...tdBase, textAlign: "center", color: "#777" }}>Групп нет</td>
                  </tr>
                ) : (
                  filtered.map((g) => {
                    const total = Number(g.totalCount || 0);
                    const signed = Number(g.signedCount || 0);
                    const actual = Number(g.actualCount || 0);
                    const status = total > 0
                      ? (actual === total ? 'Актуален' : (signed === total ? 'Согласован' : 'Черновик'))
                      : 'Черновик';
                    const rowBg = status === 'Актуален' ? '#e7f0ff' : (status === 'Согласован' ? '#e7f6d4' : 'transparent');
                    const period = (g.fromMonth && g.fromYear && g.toMonth && g.toYear)
                      ? `${String(g.fromMonth).padStart(2,'0')}.${g.fromYear} — ${String(g.toMonth).padStart(2,'0')}.${g.toYear}`
                      : '—';
                    return (
                      <tr
                        key={g.id}
                        onClick={(e) => { if (e.ctrlKey) return; setSelectedId(g.id); }}
                        onDoubleClick={(e) => { e.stopPropagation(); window.open(`${window.location.origin}/groups/${g.id}`, '_blank'); }}
                        style={{
                          ...rowBaseStyle,
                          background: rowBg,
                          cursor: "pointer",
                          ...(selectedId === g.id ? selectedRowExtras : {}),
                        }}
                      >
                        <td style={tdBase} onClick={(e)=>fillFilterByCell('id', g.id, e)}>
                          <Link to={`/groups/${g.id}`} style={journalLinkStyle}>
                            {g.id}
                          </Link>
                        </td>
                        <td style={tdBase} onClick={(e)=>fillFilterByCell('name', g.name, e)}>{g.name}</td>
                        <td style={tdBase} onClick={(e)=>fillFilterByCell('period', period, e)}>{period}</td>
                        <td style={tdBase} onClick={(e)=>fillFilterByCell('status', status, e)}>
                          <span style={statusBadgeStyle(status)}>{status}</span>
                        </td>
                        <td style={{ ...tdBase, color: g.description ? "inherit" : "#999" }} onClick={(e)=>fillFilterByCell('description', g.description||'—', e)}>{g.description || "—"}</td>
                        <td style={tdBase} onClick={(e)=>fillFilterByCell('createdAt', g.createdAt ? new Date(g.createdAt).toLocaleString() : '—', e)}>{g.createdAt ? new Date(g.createdAt).toLocaleString() : "—"}</td>
                        <td style={{ ...tdBase, whiteSpace: 'nowrap', textAlign: 'center' }}>
                          <button
                            title="Удалить группу"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!window.confirm("Удалить группу?")) return;
                              fetch(`${API}/${g.id}`, { method: "DELETE" })
                                .then((r) => r.json())
                                .then((ans) => {
                                  if (ans && ans.ok) setGroups((list) => list.filter((x) => x.id !== g.id));
                                  else if (ans && ans.error === 'has_cards') alert('Нельзя удалить: в группе есть карточки');
                                  else alert('Ошибка удаления');
                                })
                                .catch((err) => alert("Ошибка удаления: " + (err?.message || err)));
                            }}
                            style={{ border: "none", background: "none", cursor: "pointer", fontSize: 18, color: "#c00" }}
                          >🗑️</button>
                        </td>
                      </tr>
                    );
                  })
                )}
                </tbody>
              </table>
            </div>
            <div style={{ marginTop: 10, fontSize: 13, color: '#475569', textAlign: 'right' }}>
              Строк: <strong>{filtered.length}</strong>
            </div>
          </>
        )}
      </div>

      {createOpen && (
        <div onClick={() => setCreateOpen(false)}
             style={{ position: "fixed", inset: 0, background: "#0008", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", padding: 18, borderRadius: 8, width: 680, maxWidth: "96%" }}>
            <h3 style={{ marginTop: 0 }}>Создать группу</h3>
            <div style={{ display: "grid", gridTemplateColumns: "180px 1fr", gap: 10, alignItems: "center" }}>
              <label style={{ textAlign: "right" }}>Объект (поиск по названию/коду):</label>
              <div>
                <input
                  value={objQuery}
                  onChange={(e) => setObjQuery(e.target.value)}
                  placeholder="Начните вводить название или код"
                  style={{ padding: "8px 10px", border: "1px solid #ccc", borderRadius: 6, width: '100%' }}
                />
                <div style={{ maxHeight: 160, overflow: 'auto', border: '1px solid #eee', borderRadius: 6, marginTop: 6 }}>
                  {(objects || [])
                    .filter(o => {
                      const q = (objQuery||'').trim().toLowerCase();
                      if (!q) return true;
                      const code = String(o.codeBase);
                      const codePadded = pad4(o.codeBase);
                      return o.name.toLowerCase().includes(q) || code.includes(q) || codePadded.includes(q);
                    })
                    .slice(0, 30)
                    .map(o => (
                      <div key={o.id}
                           onClick={() => { setSelectedObject(o); setObjQuery(`${pad4(o.codeBase)} ${o.name}`); }}
                           style={{ padding: '6px 10px', cursor: 'pointer', background: selectedObject?.id===o.id? '#eef5ff' : 'transparent' }}>
                        <strong style={{ width: 64, display: 'inline-block' }}>{pad4(o.codeBase)}</strong> {o.name}
                      </div>
                    ))}
                </div>
              </div>

              <label style={{ textAlign: "right" }}>Период с:</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <select value={fromMonth} onChange={(e)=> setFromMonth(Number(e.target.value))}>
                  {Array.from({length:12}, (_,i)=>i+1).map(m => <option key={m} value={m}>{String(m).padStart(2,'0')}</option>)}
                </select>
                <input type="number" value={fromYear} onChange={(e)=> setFromYear(Number(e.target.value))} style={{ width: 100 }} />
              </div>

              <label style={{ textAlign: "right" }}>Период по:</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <select value={toMonth} onChange={(e)=> setToMonth(Number(e.target.value))}>
                  {Array.from({length:12}, (_,i)=>i+1).map(m => <option key={m} value={m}>{String(m).padStart(2,'0')}</option>)}
                </select>
                <input type="number" value={toYear} onChange={(e)=> setToYear(Number(e.target.value))} style={{ width: 100 }} />
              </div>

              <label style={{ textAlign: "right" }}>Название группы:</label>
              <div style={{ padding: "8px 10px", border: "1px solid #eee", borderRadius: 6, background: '#fafafa' }}>
                {selectedObject ? selectedObject.name : '— выберите объект —'}
              </div>

              <label style={{ textAlign: "right" }}>Код группы:</label>
              <div style={{ padding: "8px 10px", border: "1px solid #eee", borderRadius: 6, background: '#fafafa' }}>
                {selectedObject ? ('Г' + pad4(selectedObject.codeBase)) : '—'}
              </div>

              <label style={{ textAlign: "right" }}>Описание:</label>
              <input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Опционально" style={{ padding: "8px 10px", border: "1px solid #ccc", borderRadius: 6 }} />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
              <button onClick={() => setCreateOpen(false)} style={{ padding: "8px 12px" }}>Отмена</button>
              <button onClick={handleCreate} style={{ padding: "8px 12px", background: "#e7f6d4", border: "1px solid #8bc34a", borderRadius: 6 }}>Создать</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
